// Add multiple minimal and pattern descriptions for different images
export const minimalpatterndescriptions = Array.from({ length: 1000 }, () => `Minimal and Pattern Series`);
export const abstractdescriptions = minimalpatterndescriptions;

export const minimalpatterncontext = Array(1000).fill("Minimal and pattern wallpapers bring timeless sophistication, balance, and modern elegance to interior spaces. With subtle geometries, clean lines, and refined textures, they transform walls into harmonious backdrops that elevate any contemporary room.");

// Base AWS S3 URL
const AWS_BASE_URL = "https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern";

// Function to get image URL with fallback between .jpeg and .jpg
const getImageUrl = (imageNumber) => {
    const jpegUrl = `${AWS_BASE_URL}/(${imageNumber}).jpeg`;
    const jpgUrl = `${AWS_BASE_URL}/(${imageNumber}).jpg`;

    // Return an object with both URLs for the component to handle
    return {
        jpeg: jpegUrl,
        jpg: jpgUrl
    };
};

// Seeded random generator (Mulberry32)
function mulberry32(seed) {
    return function () {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Deterministic shuffle using seed
function seededShuffle(array, seed = 123456) {
    const rng = mulberry32(seed);
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Generate wall data (65 images)
const generateWalldata = () =>
    Array.from({ length: 65 }, (_, index) => {
        const imgNum = index + 1;
        const imageUrls = getImageUrl(imgNum);

        return {
            Img: imageUrls.jpg, // Default to jpg as in AWS S3 link provided, component handles fallback
            ImgJpg: imageUrls.jpg, // Backup jpg URL
            ImgJpeg: imageUrls.jpeg, // Backup jpeg URL
            title: `#MP${String(imgNum).padStart(3, '0')}`,
            desc: minimalpatterndescriptions[index] || "Default description",
            context: minimalpatterncontext[index] || "Default context",
            btn: 'View Detail',
        };
    });

// Shuffle the data with a fixed seed
export const walldata = seededShuffle(generateWalldata(), 42);
